import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalLoaderComponent } from '../../Shared/Components/global-loader/global-loader.component';
import { ThemeService } from '../../Shared/Services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GlobalLoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('avyna-onboarding');

  constructor() {
    inject(ThemeService);
  }
}
